export var OrderActionTypeEnum;
(function (OrderActionTypeEnum) {
    OrderActionTypeEnum["REFUND_ORDER"] = "REFUND_ORDER";
    OrderActionTypeEnum["CANCEL_ORDER"] = "CANCEL_ORDER";
    OrderActionTypeEnum["CONFIRM_ORDER"] = "CONFIRM_ORDER";
    OrderActionTypeEnum["CHANGE_STATUS"] = "CHANGE_STATUS";
    OrderActionTypeEnum["CONFIRM_ARRIVAL"] = "CONFIRM_ARRIVAL";
    OrderActionTypeEnum["UPDATE_REFUNDED_AMOUNT"] = "UPDATE_REFUNDED_AMOUNT";
})(OrderActionTypeEnum || (OrderActionTypeEnum = {}));
//# sourceMappingURL=OrderActionTypeEnum.js.map